import { useQuery } from '@tanstack/react-query';
import { edupassClient } from '../@clients';
import { type Certificate } from '@/data/certificates/interfaces';

type UseIndexReturn = {
  certificate: Certificate | null;
  isFetching: boolean;
  isInvalid: boolean;
};

export const useCertificatesIndex = ({
  uuid,
}: {
  uuid: string;
}): UseIndexReturn => {
  const { data, isFetching, error } = useQuery<Certificate>({
    queryKey: ['certificates', uuid],
    queryFn: async () => edupassClient.get(`/certificates/${uuid}`),
    enabled: !!uuid,
  });

  const certificate = data || null;
  const isInvalid = !certificate || !!error;

  return {
    certificate,
    isFetching,
    isInvalid,
  };
};
